/**
 * Hook para contagem de renders - debug mode apenas
 */
import { useRef, useEffect } from "react";
import { DEBUG_CHAT, debugLog } from "@/config/debug";

export function useRenderCount(label: string) {
  const countRef = useRef(0);
  countRef.current += 1;
  
  // **TEMPORÁRIO**: Desabilitar logs de render para focar na correção
  const logRenders = false;
  
  useEffect(() => {
    if (DEBUG_CHAT && logRenders) {
      debugLog.render(`${label} #${countRef.current}`);
    }
  });
  
  return countRef.current;
}